module.exports = __webpack_public_path__ + "static/img/logo.fd9d46c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.png
// module id = KItN
// module chunks = 1